<template>
  <a-row :gutter="24">
    <a-col :md="24">
      <a-card :style="cardStyle" :bordered="false">
        <div class="table-page-search-wrapper">
          <a-form layout="inline" @keyup.enter.native="searchQuery">
            <a-row :gutter="24">
              <a-col :md="5" :sm="24">
                <a-form-item label="单号" :labelCol="labelCol" :wrapperCol="wrapperCol">
                  <a-input placeholder="请输入FTDD单号查询" v-model="queryParam.billNo"></a-input>
                </a-form-item>
              </a-col>
              <a-col :md="4" :sm="24">
                <a-form-item label="审核状态" :labelCol="labelCol" :wrapperCol="wrapperCol">
                  <a-select placeholder="全部" allow-clear v-model="queryParam.auditStatus">
                    <a-select-option value="0">未审核</a-select-option>
                    <a-select-option value="1">已审核</a-select-option>
                    <a-select-option value="9">审核中</a-select-option>
                  </a-select>
                </a-form-item>
              </a-col>
              <a-col :md="7" :sm="24">
                <a-form-item label="创建时间" :labelCol="labelCol" :wrapperCol="wrapperCol">
                  <a-range-picker
                    style="width: 100%"
                    show-time
                    format="YYYY-MM-DD HH:mm:ss"
                    v-model="queryTimeRange"
                    @change="onTimeChange" />
                </a-form-item>
              </a-col>
              <span style="float: left;overflow: hidden;" class="table-page-search-submitButtons">
                <a-col :md="4" :sm="24">
                  <a-button type="primary" @click="searchQuery">查询</a-button>
                  <a-button style="margin-left: 8px" @click="searchReset">重置</a-button>
                </a-col>
              </span>
            </a-row>
          </a-form>
        </div>
        <section>
          <a-table
            ref="table"
            size="middle"
            bordered
            rowKey="id"
            :columns="columns"
            :dataSource="dataSource"
            :pagination="false"
            :scroll="scroll"
            :loading="loading"
            @change="handleTableChange">
            <template slot="auditStatus" slot-scope="text">
              <a-tag v-if="text === '0'" color="red">未审核</a-tag>
              <a-tag v-else-if="text === '9'" color="orange">审核中</a-tag>
              <a-tag v-else color="green">已审核</a-tag>
            </template>
            <template slot="claimStatus" slot-scope="text">
              <a-tag v-if="text === '0'" color="orange">待认领</a-tag>
              <a-tag v-else color="green">正常</a-tag>
            </template>
            <template slot="status" slot-scope="text">
              <a-tag v-if="text === '0'" color="orange">待校正</a-tag>
              <a-tag v-else color="green">已生成订单</a-tag>
            </template>
            <span slot="action" slot-scope="text, record">
              <a @click="goDetail(record)">详情</a>
              <a-popconfirm v-if="record.auditStatus === '0' && canAudit" style="margin-left: 8px"
                        title="确定审核通过该发图单吗?" @confirm="() => handleAudit(record)">
                <a>审核</a>
              </a-popconfirm>
              <a-popconfirm v-if="record.auditStatus === '0' && canSubmitFlow" style="margin-left: 8px"
                        title="确定提交该发图单至审批流程吗?" @confirm="() => handleSubmitFlow(record)">
                <a>提交流程</a>
              </a-popconfirm>
            </span>
          </a-table>
        </section>
        <a-pagination
          style="margin-top: 16px; text-align: right"
          :current="ipagination.current"
          :pageSize="ipagination.pageSize"
          :total="ipagination.total"
          @change="paginationChange"
          @showSizeChange="paginationShowSizeChange"
        />
      </a-card>
    </a-col>
  </a-row>
</template>
<script>
import { JeecgListMixin } from '@/mixins/JeecgListMixin'
import { getImgAuditConfig, auditImgOrder, submitWorkflowTask } from '@/api/plugin/orderReceive'
import moment from 'moment'

// 发图开单列表（菜单2711，客户视角：customer_tenant_id=请求者，direction=out）
export default {
  name: 'ImgOutboundList',
  mixins: [JeecgListMixin],
  data() {
    return {
      labelCol: { span: 6 },
      wrapperCol: { span: 17 },
      queryParam: {
        billNo: '',
        auditStatus: undefined,
        beginTime: moment().subtract(1, 'days').format('YYYY-MM-DD') + ' 00:00:00',
        endTime: moment().format('YYYY-MM-DD') + ' 23:59:59'
      },
      // 日期默认最近两个自然日：昨日00:00:00 ~ 今日23:59:59
      queryTimeRange: [moment().subtract(1, 'days').startOf('day'), moment().endOf('day')],
      auditConfig: { multiOn: false, flowOn: false },
      columns: [
        {
          title: '序号',
          dataIndex: '',
          key: 'rowIndex',
          width: 60,
          align: 'center',
          customRender: function(t, r, index) {
            return parseInt(index) + 1
          }
        },
        {
          title: '单号',
          dataIndex: 'billNo',
          width: 180
        },
        {
          title: '供应商',
          dataIndex: 'supplierName',
          width: 160
        },
        {
          title: '审核状态',
          dataIndex: 'auditStatus',
          width: 90,
          align: 'center',
          scopedSlots: { customRender: 'auditStatus' }
        },
        {
          title: '认领状态',
          dataIndex: 'claimStatus',
          width: 90,
          align: 'center',
          scopedSlots: { customRender: 'claimStatus' }
        },
        {
          title: '单据状态',
          dataIndex: 'status',
          width: 110,
          align: 'center',
          scopedSlots: { customRender: 'status' }
        },
        {
          title: '图片数',
          dataIndex: 'imgCount',
          width: 80,
          align: 'center'
        },
        {
          title: '备注',
          dataIndex: 'remark'
        },
        {
          title: '创建时间',
          dataIndex: 'createTime',
          width: 160
        },
        {
          title: '操作',
          dataIndex: 'action',
          width: 200,
          align: 'center',
          scopedSlots: { customRender: 'action' }
        }
      ],
      url: {
        list: '/api/plugin/order-receive/img-orders'
      }
    }
  },
  computed: {
    // 未审核行显示"审核"：未开启多级审核，或开启但未配置流程（口径同 ApprovalButtonMixin）
    canAudit() {
      return !this.auditConfig.multiOn || !this.auditConfig.flowOn
    },
    // 未审核行显示"提交流程"：开启多级审核且已配置发布流程
    canSubmitFlow() {
      return this.auditConfig.multiOn && this.auditConfig.flowOn
    }
  },
  created() {
    this.loadAuditConfig()
  },
  methods: {
    // 发图单（FTDD）审核配置：决定未审核行显示"审核"还是"提交流程"
    loadAuditConfig() {
      getImgAuditConfig('FTDD').then((res) => {
        if (res.code === 200 && res.data) {
          this.auditConfig = { multiOn: !!res.data.multiOn, flowOn: !!res.data.flowOn }
        }
      })
    },
    getQueryParams() {
      return {
        currentPage: this.ipagination.current,
        pageSize: this.ipagination.pageSize,
        billNo: this.queryParam.billNo,
        auditStatus: this.queryParam.auditStatus,
        direction: 'out',
        beginTime: this.queryParam.beginTime,
        endTime: this.queryParam.endTime
      }
    },
    // 重置查询（覆盖 mixin，恢复默认日期：最近两个自然日）
    searchReset() {
      this.queryParam = {
        billNo: '',
        auditStatus: undefined,
        beginTime: moment().subtract(1, 'days').format('YYYY-MM-DD') + ' 00:00:00',
        endTime: moment().format('YYYY-MM-DD') + ' 23:59:59'
      }
      this.queryTimeRange = [moment().subtract(1, 'days').startOf('day'), moment().endOf('day')]
      this.loadData(1)
    },
    onTimeChange(dates) {
      if (dates && dates.length === 2) {
        this.queryParam.beginTime = dates[0].format('YYYY-MM-DD HH:mm:ss')
        this.queryParam.endTime = dates[1].format('YYYY-MM-DD 23:59:59')
      } else {
        this.queryParam.beginTime = ''
        this.queryParam.endTime = ''
      }
    },
    // 审核发图单（'0'→'1'）
    handleAudit(record) {
      auditImgOrder(record.id).then((res) => {
        if (res.code === 200) {
          this.$message.success('审核成功')
          this.loadData()
        } else {
          this.$message.warning(res.message || '审核失败')
        }
      })
    },
    // 提交发图单至审批流程（bigType=10 发图单）
    handleSubmitFlow(record) {
      submitWorkflowTask(10, record.billNo).then((res) => {
        if (res && res.code === 200) {
          this.$message.success('提交流程成功')
          this.loadData()
        } else {
          this.$message.warning((res && res.data && res.data.message) || '提交流程失败')
        }
      })
    },
    // 查看详情（跳转 OCR 校正工作台，与发图收单列表一致）
    goDetail(record) {
      this.$router.push({ path: '/plugin/order-receive/imgorder/workbench', query: { id: record.id, from: 'outbound' } })
    },
    paginationChange(current, pageSize) {
      this.ipagination.current = current
      this.ipagination.pageSize = pageSize
      this.loadData()
    },
    paginationShowSizeChange(current, pageSize) {
      this.ipagination.current = 1
      this.ipagination.pageSize = pageSize
      this.loadData()
    }
  }
}
</script>
<style scoped>
.table-page-search-wrapper { margin-bottom: 15px; }
</style>
